import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function getAccount() {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/user/currentuser',
        headers: getApiHeader(),
        withCredentials: true,
    }
    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/settingAccount.js